import { PropsWithChildren } from 'react';

import { colors } from '../../colors';
import { u } from '../../styles/unit';
import { CaretRightIcon } from '../icons';
import { Stack } from '../Layout';
import { Heading4 } from '../Text';

import * as css from './NavigationMenu.css';

export const NavigationMenu = ({ children, title }: PropsWithChildren<{ title: string }>) => {
    return (
        <Stack>
            <Heading4 p={u(2)}>{title}</Heading4>
            <Stack gap={0}>{children}</Stack>
        </Stack>
    );
};

type NavigationMenuItemProps = Pick<React.DOMAttributes<HTMLButtonElement>, 'onClick'> & { active: boolean };

export const NavigationMenuItem = ({ children, onClick, active }: PropsWithChildren<NavigationMenuItemProps>) => {
    return (
        <button onClick={onClick} className={css.item}>
            <span className={active ? css.activeItem : undefined}>{children}</span>
            {active && <CaretRightIcon color={colors.blue[500]} />}
        </button>
    );
};
